import FeatherIcon from 'feather-icons-react';
import React from 'react'
import { useLocation, Link } from 'react-router-dom';

const LinkContainer = ({Icon, title, to, href,description, IconType}) => {
  const { pathname } = useLocation();

  return (
    <>
        {
          href ?
          <a href={href} className={` transition-all  mb-1 rounded-[6px] group flex space-x-3 py-1.5 hover:bg-primary/10  px-2 mx-4 items-center  justify-start`}>
            {/* {
              Icon && 
              // <Icon className={`transition-all flex-shrink-0  group-hover:text-primary text-xl ${pathname === to ? "text-primary" : "text-t-light"}`} />
              <FeatherIcon icon={Icon} className={`transition-all flex-shrink-0  group-hover:text-primary text-xl ${pathname === to ? "text-primary" : "text-t-light"}`} />
            } */}
            <p className={`transition-all text-sm font-medium text-t-light  group-hover:text-primary  `}>
              {
                title
              }
              {
                description &&
                <p className='text-[9px] mt-2 leading-none text-t-light/90'>{description}</p>
              }
            </p>
      </a>
       :
       <Link to={to} className={` transition-all  mb-2 rounded-[6px] group flex space-x-2 py-1.5 mx-4 px-2 hover:bg-primary/10 ${pathname === to ? "text-primary bg-primary/10 font-semibold" : ""} items-center justify-start`}>
            {
              Icon && 
              
                IconType === "featherIcon" ? 
                <FeatherIcon size="18" icon={Icon} className={`transition-all flex-shrink-0  group-hover:text-primary text-xl ${pathname === to ? "text-primary" : "text-t-light"}`} />
              :
              <Icon className={`transition-all flex-shrink-0  group-hover:text-primary text-xl ${pathname === to ? "text-primary" : "text-t-light"}`} />
            }
            <span className={`transition-all text-sm font-medium   group-hover:text-primary   ${pathname === to ? "text-primary font-semibold" : "text-t-light"}`}>
              {
                title
              }
            </span>
      </Link>
        }
    </>
  )
}

export default LinkContainer